import { AlertCircle } from 'lucide-react'
import { cn } from '@/lib/utils'

interface ErrorAlertProps {
  message: string | null
  className?: string
}

export function ErrorAlert({ message, className }: ErrorAlertProps) {
  if (!message) return null

  return (
    <div className={cn(
      "mt-4 p-3 bg-red-500/20 border border-red-500/30 text-red-400 rounded-lg text-sm flex items-start gap-2",
      className
    )}>
      <AlertCircle className="h-4 w-4 mt-0.5 flex-shrink-0" />
      <span>{message}</span>
    </div>
  )
}
